import { Tooltip, Typography } from '@mui/material';

const TooltipComp = ({ value, bold }) => {
  return (
    <Tooltip title={value} placement="right">
      {bold ? (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {' '}
          {value}
        </Typography>
      ) : (
        <span
          style={{
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: bold && 'bold',
          }}
        >
          {value}
        </span>
      )}
    </Tooltip>
  );
};
export default TooltipComp;
